import { SignatureSingleActionProps } from 'components/tables/data/signature/types';
import { Menu, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Cancel sign action for signatures.
 * Note: Backend endpoint is not yet implemented.
 */
export default function CancelSignAction({ signature, kind }: SignatureSingleActionProps) {
  /**
   * Handles cancel sign action (placeholder until backend is implemented).
   */
  const handleCancelSign = () => {
    // TODO: Implement when backend endpoint is ready
  };

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Zrušiť podpis" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" onClick={handleCancelSign}>
          <IconX stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" onClick={handleCancelSign} leftIcon={<IconX stroke={1.5} size={24} />} variant="secondary">
        Zrušiť podpis
      </Button>
    );
  }

  return (
    <Menu.Item
      color="gray.8"
      onClick={handleCancelSign}
      icon={<IconX stroke={1.5} size={24} />}
      disabled={true} // Disabled until backend is ready
    >
      Zrušiť podpis
    </Menu.Item>
  );
}
